import React from 'react';
import { Link } from "react-router-dom";


const Footer = () =>{
  return(
<>
<footer className='container-fluid w-100 p-0 bg-white py-4 text-center footer_fixed'>
    <div className='col'>
    <p className='m-0'>Copyright © <Link className='text-decoration-none' to="/"> Khoja Business Directory</Link>&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;<Link className='text-decoration-none' to="/privacy-policy"> Privacy Policy </Link> &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp; <Link className='text-decoration-none' to="/terms-and-conditions"> Terms & Conditions </Link></p>
    </div>
</footer>
</>
  )}
export default Footer;